import { render, staticRenderFns } from "./AxUserAvatar.vue?vue&type=template&id=b36877bc&scoped=true&"
import script from "./AxUserAvatar.vue?vue&type=script&lang=ts&"
export * from "./AxUserAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./AxUserAvatar.vue?vue&type=style&index=0&id=b36877bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36877bc",
  null
  
)

export default component.exports